function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCountdown = function SvgCountdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    stroke: "#fff",
    className: "countdown_svg__icon countdown_svg__flat-color",
    "data-name": "Flat Color",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7 9.2a1 1 0 0 1-.7-.3L4.49 7.41A1 1 0 0 1 5.91 6L7.4 7.49a1 1 0 0 1 0 1.41 1 1 0 0 1-.7.3Zm10.6 0a1 1 0 0 1-.7-.3 1 1 0 0 1 0-1.41L18.09 6a1 1 0 1 1 1.42 1.42L18 8.9a1 1 0 0 1-.7.3ZM12 7a1 1 0 0 1-1-1V4H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-1 1Z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.5,
    r: 8.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 16.57a1 1 0 0 1-.74-1.66L11 13.62V10a1 1 0 0 1 2 0v4a1 1 0 0 1-.25.67l-1.4 1.57a1 1 0 0 1-.75.33Z",
    "data-name": "secondary",
    style: {
      fill: "#000"
    }
  }));
};
export default SvgCountdown;